/**
 * Tipos de impressora
 * @type {Record<string, 'common' | 'thermal'>}
 * @property {'common'} COMMON Impressora comum
 * @property {'thermal'} THERMAL Impressora térmica
 */
export const PRINT_TYPES = {
  COMMON: 'common',
  THERMAL: 'thermal',
};

/**
 * Qualidades de impressão
 * @type {Record<string, 'default' | 'high'>}
 * @property {'default'} DEFAULT Qualidade padrão (etiquetas em formato de imagem)
 * @property {'high'} HIGH Qualidade alta (etiquetas em HTML)
 */
export const PRINT_QUALITIES = {
  DEFAULT: 'default',
  HIGH: 'high',
};